var portfolioPositionsWeight = {
	caption: "Peso de las posiciones del portafolio",
	label: {
		name: "Nombre",
		isin: "ISIN",
		marketValue: "Valor de mercado",
		weight: "Peso %",
		weightBar: "Peso % of max"
	},
	noPositions: "Sin resultados"
};
var es = {
	portfolioPositionsWeight: portfolioPositionsWeight
};

export { es as default, portfolioPositionsWeight };
